import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, OnChanges, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { EventManagerService } from '../../../blog/event-manager.service';


@Component({
    selector: 'documents-fund',
    templateUrl: './documents-fund.html',
    styleUrls: ['./documents-fund.scss', '../tab-detail-fund.scss'],
})

export class DocumentsFund implements OnInit {
    @Input('documents') documents: any;
    listProspectus: any[] = [];
    listSummaryProspectus: any[] = [];
    listRegulation: any[] = [];
    constructor(
        public eventManager: EventManagerService,
        public router: Router,) {
    }

    ngOnInit() {
        this.documents  = this.documents || [];
        this.documents.forEach((document: any) => {
            switch (document.documentType.code) {
                case 'PROSPECTUS_FUND':
                    this.listProspectus.push(document);
                break;
                case 'SUMMARY_PROSPECTUS_FUND':
                    this.listSummaryProspectus.push(document);
                break;
                case 'REGULATION_FUND':
                    this.listRegulation.push(document);
                break;
            }
        })
    }
}
